import { __read } from "tslib";
import React, { useEffect, useState } from 'react';
import { heapTrackEvent } from '@marvelapp/core';
import { Box, Button, Flex, Link, PinBR, Text } from '@marvelapp/ui';
import { SIGN_UP_THROUGH_PLAYER } from '../constants/hubspotEventIds';
import * as marvelURL from '../constants/marvelURL';
import { CrossIcon, GoogleLogo, UpsellLogo } from './icons';
var PUBLIC = 'player-public-banner';
var AUTHENTICATED = 'player-authenticated-banner';
var APPEARED_HEAP_EVENT_NEW = 'Player Marvel Banner Appeared';
var CLICKED_HEAP_EVENT = 'Player Marvel Banner Clicked';
var CLICK_SIGNUP_GOOGLE_EVENT = 'Player Marvel Banner Clicked Signup Google';
var CLICK_SIGNUP_EVENT = 'Player Marvel Banner Clicked Signup';
var CLICK_CLOSE_EVENT = 'Player Marvel Banner Clicked Close';
var SIGN_UP_ORIGIN = 'sign_up_origin';
export default function Banner(_a) {
    var isUserAuthenticated = _a.isUserAuthenticated, isUserPartOfThisCompany = _a.isUserPartOfThisCompany, onMobileDevice = _a.onMobileDevice;
    useEffect(function () {
        var params = new URLSearchParams(window.location.search);
        if (params.get(SIGN_UP_ORIGIN) === 'player') {
            heapTrackEvent('Sign Up Through Player');
            if (window._hsq) {
                window._hsq.push([
                    'trackEvent',
                    {
                        id: SIGN_UP_THROUGH_PLAYER,
                    },
                ]);
            }
        }
    }, []);
    return (React.createElement(SignUpToMarvel, { isUserAuthenticated: isUserAuthenticated, isUserPartOfThisCompany: isUserPartOfThisCompany, onMobileDevice: onMobileDevice }));
}
export function SignUpToMarvel(_a) {
    var isUserAuthenticated = _a.isUserAuthenticated, isUserPartOfThisCompany = _a.isUserPartOfThisCompany, onMobileDevice = _a.onMobileDevice;
    var identifier = isUserAuthenticated ? AUTHENTICATED : PUBLIC;
    var _b = __read(useState(!isUserAuthenticated), 2), showSignUpPopover = _b[0], setShowSignUpPopover = _b[1];
    var next = "/?next=".concat(encodeURIComponent("".concat(window.location.pathname, "?").concat(SIGN_UP_ORIGIN, "=player")));
    var emailSignUp = marvelURL.SIGN_UP + next;
    var googleSignUp = marvelURL.SIGN_UP_GOOGLE + next;
    var link = isUserAuthenticated ? marvelURL.HOMEPAGE : emailSignUp;
    if (isUserAuthenticated && isUserPartOfThisCompany) {
        link = marvelURL.UPGRADE;
    }
    useEffect(function () {
        heapTrackEvent(APPEARED_HEAP_EVENT_NEW, {
            identifier: identifier,
        });
    }, [identifier]);
    return (React.createElement(React.Fragment, null,
        showSignUpPopover && (React.createElement(Flex, { alignItems: "center", bg: "white", borderRadius: 3, bottom: ['auto', 10], boxShadow: "card.raised", "data-testid": "signup-to-marvel", fill: "marvel", flexDirection: "column", justifyContent: "center", left: ['50%', 'auto'], ml: [-110, 0], mt: [-130, 0], padding: 4, position: "absolute", right: ['auto', 10], top: ['50%', 'auto'], width: [220, 258], zIndex: 100 },
            React.createElement(Flex, { alignItems: "center", color: "black", cursor: "pointer", height: 40, hoverColor: "licorice", justifyContent: "center", onClick: function () {
                    setShowSignUpPopover(false);
                    heapTrackEvent(CLICK_CLOSE_EVENT);
                }, position: "absolute", right: 0, top: 0, width: 40 },
                React.createElement(CrossIcon, { height: 10, width: 10 })),
            React.createElement(Box, { mb: 3, mt: 2 },
                React.createElement(UpsellLogo, { height: 29, width: 68 })),
            React.createElement(Text, { color: "licorice", fontSize: [2, 3], fontWeight: 600, mb: 3, textAlign: "center" }, "Sign up to collaborate and feedback on this prototype"),
            React.createElement(Flex, { flexDirection: "column", justifyContent: "stretch" },
                React.createElement(Link, { "data-testid": "google-signup-button", display: "block", href: googleSignUp, onClick: function () {
                        heapTrackEvent(CLICK_SIGNUP_GOOGLE_EVENT);
                    } },
                    React.createElement(Button, { kind: "ghost", mb: 2, size: 2 },
                        React.createElement(Flex, { alignItems: "center", justifyContent: "center" },
                            React.createElement(Box, { mr: 2 },
                                React.createElement(GoogleLogo, { height: 16, width: 16 })),
                            React.createElement(Box, null, "Sign up with Google")))),
                React.createElement(Link, { "data-testid": "email-signup-button", display: "block", href: emailSignUp, onClick: function () { return heapTrackEvent(CLICK_SIGNUP_EVENT); } },
                    React.createElement(Button, { kind: "marvel", size: 2, width: "100%" }, "Sign up with email"))),
            React.createElement(Link, { fontSize: [1, 2], fontWeight: 500, kind: "marvel", mt: 3, onClick: function () {
                    setShowSignUpPopover(false);
                    heapTrackEvent(CLICK_CLOSE_EVENT);
                } }, "Dismiss"))),
        !onMobileDevice && !showSignUpPopover && (React.createElement(PinBR, { pb: 10, pr: 10 },
            React.createElement(BallparkUpsell, null)))));
}
export function BallparkUpsell() {
    return (React.createElement(Button, { kind: "toolbar", borderRadius: 1, height: 34 },
        React.createElement(Link, { "data-testid": "ballpark-upsell", href: "https://ballparkhq.com/?utm_campaign=Ballpark%20Launch%200422&utm_source=Marvel%20website&utm_medium=prototype-banner", target: "_blank" },
            React.createElement("div", { "data-testId": "ballpark-upsell" },
                React.createElement("span", { role: "img", "aria-label": "Video camera" }, "\uD83D\uDCF9"),
                '  ',
                "Test this prototype"))));
}
